<script lang="js">
// Import the base component class
import { Pie } from 'vue-chartjs';

export default {
    // Use 'extends' and include 'mixins' for reactivity
    extends: Pie,
    name: 'chartjsPieChart',
    props: {
        seriesData: {
            type: Array,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        spaceRemaining:{
            type: Number,
            required: true,
        },
    },
    mounted () {
        this.renderChart(this.chartData, this.chartOptions);
    },
    computed: {
        chartData (){
            return {//chart data
                labels: ['Used', 'Free'],
                datasets: [
                    {
                        label: 'Space (%)',
                        data: [this.seriesData[0].y, this.seriesData[1].y],
                        backgroundColor: [
                            '#00355c', // Used
                            '#91b0e1'  // Free
                        ],
                        // Colors for the border
                        borderColor: '#fff',
                        borderWidth: 1
                    }
                ]
            };
        },
        chartOptions (){
            return {//chart options
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: true,
                    text: this.name,
                    fontSize: 18,
                    position: 'top',

                },
                legend: {
                    position: 'bottom'
                },
                tooltips: {
                    callbacks: {
                    // Customize tooltip to show percentage and value
                        label: (tooltipItem, data) => {
                            const diskPercentage = this.seriesData[tooltipItem.index].y;
                            const diskValue = this.seriesData[tooltipItem.index].z;
                            const diskScale = this.seriesData[tooltipItem.index].g;
                            const diskLabel = this.seriesData[tooltipItem.index].name;

                            return `${diskLabel}: ${diskValue}${diskScale} (${diskPercentage})%`;
                        }
                    }
                }
            };
        }
    },
    watch: {
        chartData: {
            handler (newVal, oldVal) {
                this.renderChart(this.chartData, this.chartOptions);
            },
            deep: true
        },
        chartOptions: {
            // Re-render the whole chart if options change
            handler () {
                this.renderChart(this.chartData, this.chartOptions);
            },
            deep: true
        }
    }
};
</script>
